import settingsDashboardConfig from '../mocks/settings-dashboard.json'

const normalizePhone = (value = '') => String(value).replace(/\D/g, '')

export const getSettingsDashboardConfig = () => settingsDashboardConfig

export const getSettingsProfileMenuOverrides = () => settingsDashboardConfig?.profileMenuOverrides || {}

export const getSettingsAdminInfo = (user) => {
	const admin = settingsDashboardConfig?.admin || {}

	return {
		name: (user) ? `${user.first_name} ${user.last_name}` : 'Nome não cadastrado',
		email: user?.email || "E-mail não cadastrado",
		phone: user?.profile?.telephone || "Telefone não cadastrado",
		supportPrompt: admin.supportPrompt || '',
		supportCta: admin.supportCta || '',
	}
}

export const getSettingsNavigationConfig = () => settingsDashboardConfig?.navigation || {}

export const getSettingsIndexConfig = () => settingsDashboardConfig?.index || {}

export const getPhoneManagementConfig = () => settingsDashboardConfig?.phoneManagement || {}

export const getBillingConfig = () => settingsDashboardConfig?.billing || {}

export const getRestrictedWordsConfig = () => settingsDashboardConfig?.restrictedWords || {}

export const getProductsAndServicesConfig = () => settingsDashboardConfig?.productsAndServices || {}

export const mergePhoneManagementRows = (accounts = []) => {
	const phoneManagement = getPhoneManagementConfig()
	const rowMap = new Map()
	const fallbackRows = []

	;(phoneManagement?.rows || []).forEach((row) => {
		rowMap.set(normalizePhone(row?.phone), row)
		fallbackRows.push({
			id: row?.id || normalizePhone(row?.phone),
			name: row?.name || 'Número monitorado',
			phone: row?.phone || '',
			statusLabel: row?.statusLabel || 'Conectado',
			conversations: row?.conversations ?? 0,
			messages: row?.messages ?? 0,
			actions: Array.isArray(row?.actions) ? row.actions : [],
		})
	})

	if (!accounts.length) {
		return fallbackRows.filter((row) => row.phone)
	}

	return accounts.map((account) => {
		const normalizedPhone = normalizePhone(account?.phone_number)
		const row = rowMap.get(normalizedPhone) || {}

		return {
			id: account?.id || normalizedPhone,
			name: account?.name || 'Número monitorado',
			phone: account?.phone_number || row?.phone || '',
			statusLabel: row?.statusLabel || 'Conectado',
			conversations: row?.conversations ?? 0,
			messages: row?.messages ?? 0,
			actions: Array.isArray(row?.actions) ? row.actions : [],
		}
	})
		.filter((row) => row.phone)
}